import React from 'react';
import './photo.css'; 
import photo1 from '../../../assets/images/photo1.png'
import photo2 from '../../../assets/images/photo2.png'
import photo3 from '../../../assets/images/photo3.png'
import photo4 from '../../../assets/images/photo4.png'
import photo5 from '../../../assets/images/photo5.png'

const photos = [
  photo1,
  photo2,
  photo3,
  photo4,
  photo5,
];

const Photocollage = () => {
  return (

    <div className='parent' >
  <div className='photo1'> <img src={photo1} /></div>
	<div className='photo2'><img src={photo2} /></div>
	<div className='photo3'><img src={photo3} /></div>
	<div className='photo4'><img src={photo5} /></div>
	<div className='photo5'><img src={photo4} /></div>
	
</div>
  );
};

export default Photocollage;
